var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIcon10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.2334 10.8057V5.8224C2.2334 3.5224 4.10007 1.66406 6.40006 1.66406H14.7334C17.0334 1.66406 18.9001 3.5224 18.9001 5.8224V11.6391C18.9001 13.9307 17.0334 15.7891 14.7334 15.7891H13.4834C13.2251 15.7891 12.9751 15.9141 12.8167 16.1224L11.5667 17.7807C11.0167 18.5141 10.1167 18.5141 9.56673 17.7807L8.31673 16.1224C8.1834 15.9391 7.8834 15.7891 7.65006 15.7891H6.40006C4.10007 15.7891 2.2334 13.9307 2.2334 11.6391V10.8057Z",
    fill: "#333548",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5667 10.0026C10.1001 10.0026 9.7334 9.6276 9.7334 9.16927C9.7334 8.71094 10.1084 8.33594 10.5667 8.33594C11.0251 8.33594 11.4001 8.71094 11.4001 9.16927C11.4001 9.6276 11.0334 10.0026 10.5667 10.0026Z",
    fill: "#333548",
    fillOpacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9 10.0026C13.4333 10.0026 13.0667 9.6276 13.0667 9.16927C13.0667 8.71094 13.4417 8.33594 13.9 8.33594C14.3583 8.33594 14.7333 8.71094 14.7333 9.16927C14.7333 9.6276 14.3667 10.0026 13.9 10.0026Z",
    fill: "#333548",
    fillOpacity: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23324 10.0026C6.76657 10.0026 6.3999 9.6276 6.3999 9.16927C6.3999 8.71094 6.7749 8.33594 7.23324 8.33594C7.69157 8.33594 8.06657 8.71094 8.06657 9.16927C8.06657 9.6276 7.6999 10.0026 7.23324 10.0026Z",
    fill: "#333548",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon10);
export default __webpack_public_path__ + "static/media/menu-icon-10.e4bd3389f0c14a746cdb22c3fb2e0eaa.svg";
export { ForwardRef as ReactComponent };